module.exports = __webpack_public_path__ + "static/img/ps-digital-lending-thumbnail.201636b.jpg";